/* The VaporSeguro variant keeps a horizontal gallery on desktop as well as mobile. */
(() => {
  /* Delivery dates in Madrid time: dispatch today before the cut-off on a
     working day, otherwise the next working day; delivery one to two
     working days after dispatch. */
  function deliveryDates(cutoff) {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    const part = type => Number(parts.find(p => p.type === type).value);
    const today = new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
    const working = d => d.getUTCDay() !== 0 && d.getUTCDay() !== 6;
    const addWorking = (from, n) => { const d = new Date(from); while (n > 0) { d.setUTCDate(d.getUTCDate() + 1); if (working(d)) n--; } return d; };
    const ship = working(today) && part('hour') < cutoff ? today : addWorking(today, 1);
    return { today, ship, first: addWorking(ship, 1), last: addWorking(ship, 2) };
  }
  function fillTimeline(root) {
    const { today, ship, first, last } = deliveryDates(parseInt(root.dataset.cutoff, 10) || 14);
    const day = new Intl.DateTimeFormat('es-ES', { day: 'numeric', timeZone: 'UTC' });
    const full = d => new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'short', timeZone: 'UTC' }).format(d).replace('.', '');
    const range = first.getUTCMonth() === last.getUTCMonth() ? day.format(first) + '–' + full(last) : full(first) + ' – ' + full(last);
    const set = (key, text) => { const el = root.querySelector('[data-vr-tl="' + key + '"]'); if (el) el.textContent = text; };
    set('order', full(today));
    set('ship', full(ship));
    set('deliver', range);
  }
  /* Stock row: a random count in the section's range, kept for the visit,
     and the delivery estimate as a date range. */
  /* Units counter: a random number between min and max, kept in a cookie for
     30 days so it survives the visit, and dropping one unit every
     `data-drop-hours` hours without going below the minimum. */
  function readUnits() {
    const m = document.cookie.match(/(?:^|; )vr_units=(\d+)\.(\d+)/);
    return m ? { count: parseInt(m[1], 10), since: parseInt(m[2], 10) } : null;
  }
  function fillStock(root) {
    const min = parseInt(root.dataset.min, 10) || 1;
    const max = Math.max(min, parseInt(root.dataset.max, 10) || min);
    const dropHours = parseFloat(root.dataset.dropHours) || 0;
    const now = Date.now();
    let saved = null;
    try { saved = readUnits(); } catch (e) {}
    if (!saved || !(saved.count >= min && saved.count <= max)) {
      saved = { count: min + Math.floor(Math.random() * (max - min + 1)), since: now };
    }
    let count = saved.count;
    if (dropHours > 0) count = Math.max(min, saved.count - Math.floor((now - saved.since) / (dropHours * 3600000)));
    try { document.cookie = 'vr_units=' + saved.count + '.' + saved.since + '; max-age=' + (60 * 60 * 24 * 30) + '; path=/; SameSite=Lax'; } catch (e) {}
    const units = root.querySelector('[data-vr-units]');
    if (units) units.textContent = count === 1 ? '1 unidad disponible' : count + ' unidades disponibles';
    const eta = root.querySelector('[data-vr-eta]');
    const { first, last } = deliveryDates(parseInt(root.dataset.cutoff, 10) || 14);
    const date = new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' });
    if (eta) eta.textContent = 'Entrega ' + date.format(first) + ' - ' + date.format(last);
  }

  /* Price info toggletip: the button opens and closes it; Escape or a click
     elsewhere closes it. */
  function initToggletip(root) {
    const button = root.querySelector('button');
    const tip = root.querySelector('[role="status"]');
    const set = open => { tip.hidden = !open; button.setAttribute('aria-expanded', String(open)); };
    button.addEventListener('click', event => { event.stopPropagation(); set(tip.hidden); });
    document.addEventListener('click', event => { if (!root.contains(event.target)) set(false); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') set(false); });
  }
  /* Retargeting countdown: shown only to visitors who first landed with the
     configured URL parameter (name=value, or just the name). The landing time
     is kept in a cookie for 30 days; the clock starts `data-delay-min` minutes
     after it and runs `data-hours` hours, then the line hides itself. */
  function readCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function initCountdown(root) {
    const demo = root.dataset.demo === 'true';
    const param = (root.dataset.param || '').trim();
    const delay = (parseFloat(root.dataset.delayMin) || 0) * 60000;
    const hours = parseFloat(root.dataset.hours) || 24;
    let since = 0;
    try { since = parseInt(readCookie('vr_rt') || '', 10) || 0; } catch (e) {}
    if (!since && param) {
      const [key, value] = param.split('=');
      const url = new URLSearchParams(location.search);
      if (url.has(key) && (value === undefined || url.get(key) === value)) {
        since = Date.now();
        try { document.cookie = 'vr_rt=' + since + '; max-age=' + (60 * 60 * 24 * 30) + '; path=/; SameSite=Lax'; } catch (e) {}
      }
    }
    if (!since && !demo) return;
    const start = since ? since + delay : Date.now();
    const end = start + hours * 3600000;
    const time = root.querySelector('[data-vr-countdown-time]');
    const pad = n => String(n).padStart(2, '0');
    let timer = 0;
    const tick = () => {
      const now = Date.now();
      if (now < start) { root.hidden = true; return; }
      const left = end - now;
      if (left <= 0) { root.hidden = true; clearInterval(timer); return; }
      time.textContent = pad(Math.floor(left / 3600000)) + ':' + pad(Math.floor(left % 3600000 / 60000)) + ':' + pad(Math.floor(left % 60000 / 1000));
      root.hidden = false;
    };
    timer = setInterval(tick, 1000);
    tick();
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-vr-timeline]').forEach(fillTimeline);
    scope.querySelectorAll('[data-vr-countdown]').forEach(initCountdown);
    /* Flags, seal and accessories badge belong to the first photo only: once
       the gallery is swiped past it, the stage hides its overlays. */
    scope.querySelectorAll('[data-vd-gallery]').forEach(gallery => {
      const stage = gallery.closest('.vd-gallery__stage');
      if (!stage || gallery.dataset.vrOverlays) return;
      gallery.dataset.vrOverlays = 'true';
      let ticking = false;
      const update = () => { ticking = false; stage.classList.toggle('vd-gallery__stage--moved', gallery.scrollLeft > gallery.clientWidth / 2); };
      gallery.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    });
    scope.querySelectorAll('[data-vr-stock]').forEach(fillStock);
    /* Stand-alone delivery range, e.g. under the closing offer button. */
    scope.querySelectorAll('[data-vr-eta-line]').forEach(el => {
      const { first, last } = deliveryDates(parseInt(el.dataset.cutoff, 10) || 14);
      const date = new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: '2-digit', timeZone: 'UTC' });
      el.textContent = 'Entrega ' + date.format(first) + ' - ' + date.format(last);
    });
    /* Review cards slide on their own every few seconds, one page at a time
       and back to the first after the last; hovering or touching pauses them. */
    scope.querySelectorAll('[data-vd-reviews]').forEach(root => {
      if (root.dataset.vrInit) return;
      root.dataset.vrInit = 'true';
      const track = root.querySelector('[data-vd-reviews-track]');
      const dotsBox = root.querySelector('[data-vd-reviews-dots]');
      const cards = [...track.children];
      if (cards.length < 2) return;
      let page = 0, paused = false;
      // Distinct scroll targets: with two cards in view the last card shares the final page.
      const pages = () => {
        const max = track.scrollWidth - track.clientWidth, left = track.getBoundingClientRect().left + track.scrollLeft;
        const list = [];
        cards.forEach(card => { const x = Math.min(Math.round(card.getBoundingClientRect().left - left), max); if (!list.includes(x)) list.push(x); });
        return list;
      };
      const dots = () => {
        if (!dotsBox) return;
        const n = pages().length;
        if (dotsBox.children.length !== n) dotsBox.replaceChildren(...Array.from({ length: n }, () => document.createElement('span')));
        [...dotsBox.children].forEach((d, i) => d.classList.toggle('is-on', i === page));
      };
      const show = i => {
        const list = pages();
        page = ((i % list.length) + list.length) % list.length;
        track.scrollTo({ left: list[page], behavior: 'smooth' });
        dots();
      };
      ['mouseenter', 'touchstart', 'focusin'].forEach(e => root.addEventListener(e, () => { paused = true; }, { passive: true }));
      ['mouseleave', 'touchend', 'focusout'].forEach(e => root.addEventListener(e, () => { paused = false; }, { passive: true }));
      window.addEventListener('resize', dots);
      dots();
      setInterval(() => { if (!paused) show(page + 1); }, (parseFloat(root.dataset.interval) || 4) * 1000);
    });
    /* Sticky gallery offset: 105px when it fits the window, otherwise just
       enough that its bottom stays visible. */
    scope.querySelectorAll('.vs-dripl .vd-gallery').forEach(gallery => {
      if (gallery.dataset.vrInit) return;
      gallery.dataset.vrInit = 'true';
      const fit = () => {
        const room = window.innerHeight - gallery.offsetHeight - 16;
        gallery.style.setProperty('--vd-gallery-top', Math.min(105, room) + 'px');
      };
      fit();
      window.addEventListener('resize', fit);
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(gallery);
    });
    /* Background and mosaic videos: muted, and only running while on screen. */
    scope.querySelectorAll('[data-vr-autoplay] video').forEach(video => {
      if (video.dataset.vrAuto) return;
      video.dataset.vrAuto = 'true';
      video.muted = true;
      const visible = () => video.getClientRects().length > 0;
      if (!('IntersectionObserver' in window)) { if (visible()) video.play().catch(() => {}); return; }
      new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && visible()) video.play().catch(() => {});
          else video.pause();
        });
      }, { threshold: 0.3 }).observe(video);
    });
    /* Lightbox: previous and next between the gallery images, with arrows, keyboard and swipe. */
    const lightbox = document.getElementById('vs-media-dialog');
    if (lightbox && !lightbox.dataset.vdNav) {
      lightbox.dataset.vdNav = 'true';
      const prev = lightbox.querySelector('[data-vd-prev]');
      const next = lightbox.querySelector('[data-vd-next]');
      const count = lightbox.querySelector('[data-vd-dialog-count]');
      const items = () => [...document.querySelectorAll('.vd-gallery__grid [data-vd-image]')];
      let index = 0;
      const show = i => {
        const list = items(); if (!list.length) return;
        index = (i + list.length) % list.length;
        const trigger = list[index];
        const container = lightbox.querySelector('[data-vd-dialog-media]');
        const media = document.createElement('img');
        media.src = trigger.dataset.vdImage; media.alt = trigger.dataset.vdCaption || 'VaporSeguro';
        container.replaceChildren(media);
        lightbox.querySelector('[data-vd-dialog-caption]').textContent = trigger.dataset.vdCaption || '';
        if (count) count.textContent = list.length > 1 ? (index + 1) + ' / ' + list.length : '';
        if (prev) prev.hidden = list.length < 2; if (next) next.hidden = list.length < 2;
      };
      document.addEventListener('click', event => {
        const trigger = event.target.closest('.vd-gallery__grid [data-vd-image]');
        if (trigger) { index = items().indexOf(trigger); setTimeout(() => show(index), 0); }
      }, true);
      prev?.addEventListener('click', event => { event.stopPropagation(); show(index - 1); });
      next?.addEventListener('click', event => { event.stopPropagation(); show(index + 1); });
      lightbox.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      });
      let touchX = null;
      lightbox.addEventListener('touchstart', event => { touchX = event.touches[0].clientX; }, { passive: true });
      lightbox.addEventListener('touchend', event => {
        if (touchX === null) return;
        const dx = event.changedTouches[0].clientX - touchX; touchX = null;
        if (Math.abs(dx) > 40) show(dx < 0 ? index + 1 : index - 1);
      }, { passive: true });
    }
    /* "Incluido en tu pedido": the box opens a popup with every accessory. */
    scope.querySelectorAll('[data-vd-kit-open]').forEach(opener => {
      if (opener.dataset.vdKitInit) return;
      opener.dataset.vdKitInit = 'true';
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      opener.addEventListener('click', () => { dialog.showModal(); dialog.focus({ preventScroll: true }); opener.setAttribute('aria-expanded', 'true'); });
      dialog.addEventListener('click', event => { if (event.target === dialog || event.target.closest('[data-vd-kit-close]')) dialog.close(); });
      dialog.addEventListener('close', () => opener.setAttribute('aria-expanded', 'false'));
    });
    scope.querySelectorAll('[data-vd-toggletip]').forEach(root => {
      if (root.dataset.vrInit) return;
      root.dataset.vrInit = 'true';
      initToggletip(root);
    });
    /* Clips all autoplay muted, started here too in case the browser held
       one back; a tap pauses or resumes it, and the tile tracks the state
       for the centre badge. */
    scope.querySelectorAll('.vr-clips__tile video').forEach(video => {
      if (video.dataset.vrInit) return;
      video.dataset.vrInit = 'true';
      const tile = video.parentElement;
      const badge = tile.querySelector('.vr-clips__play');
      const sync = () => {
        tile.classList.toggle('is-playing', !video.paused);
        badge?.setAttribute('aria-label', video.paused ? 'Reproducir vídeo' : 'Pausar vídeo');
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.muted = true;
      let userPaused = false;
      const start = () => { if (!userPaused) video.play().catch(() => {}); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.isIntersecting) start(); else if (!video.paused) video.pause(); });
        }, { threshold: 0.25 }).observe(video);
      } else {
        start();
      }
      sync();
      tile.addEventListener('click', () => { if (video.paused) { userPaused = false; video.play(); } else { userPaused = true; video.pause(); } });
    });
    scope.querySelectorAll('[data-vr-strip]').forEach(root => {
      if (root.dataset.vrInit) return;
      root.dataset.vrInit = 'true';
      const track = root.querySelector('[data-vr-strip-track]');
      const thumb = root.querySelector('[data-vr-strip-thumb]');
      if (!track || !thumb) return;
      const bar = thumb.parentNode;
      const sync = () => {
        const end = track.scrollWidth - track.clientWidth;
        bar.hidden = end <= 1;
        const share = end > 1 ? track.clientWidth / track.scrollWidth : 1;
        thumb.style.width = (share * 100) + '%';
        thumb.style.transform = 'translateX(' + (end > 1 ? (track.scrollLeft / end) * (bar.clientWidth * (1 - share)) : 0).toFixed(1) + 'px)';
      };
      track.addEventListener('scroll', sync, { passive: true });
      new ResizeObserver(sync).observe(track);
    });
    scope.querySelectorAll('[data-vr-reviews]').forEach(root => {
      if (root.dataset.vrInit) return;
      root.dataset.vrInit = 'true';
      const list = root.querySelector('[data-vr-review-list]');
      const cards = [...root.querySelectorAll('[data-vr-review]')];
      const filter = root.querySelector('[data-vr-review-filter]');
      const sort = root.querySelector('[data-vr-review-sort]');
      const more = root.querySelector('[data-vr-review-more]');
      const bars = [...root.querySelectorAll('[data-vr-review-bar]')];
      const pageSize = window.matchMedia('(max-width: 749px)').matches ? 8 : 6;
      let limit = pageSize;
      function update() {
        const matches = cards.filter(card => filter.value === 'all' || card.dataset.rating === filter.value);
        matches.sort((a, b) => {
          const rating = Number(b.dataset.rating) - Number(a.dataset.rating);
          return (sort.value === 'highest' ? rating : sort.value === 'lowest' ? -rating : 0) || Number(a.dataset.index) - Number(b.dataset.index);
        });
        cards.forEach(card => { card.hidden = true; });
        matches.forEach((card, index) => { list.append(card); card.hidden = index >= limit; });
        bars.forEach(bar => bar.setAttribute('aria-pressed', String(bar.dataset.vrReviewBar === filter.value)));
        const shown = Math.min(matches.length, limit);
        root.querySelector('[data-vr-review-status]').textContent = `${shown} de ${matches.length} opiniones${filter.value === 'all' ? '' : ` · ${filter.value} estrellas`}`;
        root.querySelector('[data-vr-review-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
      }
      const change = () => { limit = pageSize; update(); };
      filter.addEventListener('change', change);
      sort.addEventListener('change', change);
      bars.forEach(bar => bar.addEventListener('click', () => {
        filter.value = filter.value === bar.dataset.vrReviewBar ? 'all' : bar.dataset.vrReviewBar;
        change();
      }));
      root.querySelector('[data-vr-review-reset]').addEventListener('click', () => {
        filter.value = 'all'; change(); filter.focus();
      });
      more.addEventListener('click', () => {
        const previousLimit = limit;
        limit += pageSize; update();
        const firstNew = [...list.children].filter(card => !card.hidden)[previousLimit];
        if (firstNew) { firstNew.tabIndex = -1; firstNew.focus({ preventScroll: true }); }
      });
      root.querySelector('[data-vr-review-controls]').hidden = false;
      update();
    });
    scope.querySelectorAll('[data-vr-spec-carousel]').forEach(root => {
      if (root.dataset.vrInit) return;
      root.dataset.vrInit = 'true';
      const track = root.querySelector('[data-vr-spec-track]');
      const cards = [...track.children];
      const previous = root.querySelector('[data-vr-spec-prev]');
      const next = root.querySelector('[data-vr-spec-next]');
      const status = root.querySelector('[data-vr-spec-status]');
      const step = () => cards[1].offsetLeft - cards[0].offsetLeft;
      const sync = () => {
        const end = track.scrollWidth - track.clientWidth;
        const index = Math.round(track.scrollLeft / step());
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft >= end - 2;
        status.textContent = `${next.disabled && end > 2 ? cards.length : index + 1} / ${cards.length}`;
      };
      const move = direction => {
        track.scrollBy({ left: direction * step(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', sync, { passive: true });
      /* Phones: a scroll bar under the cards replaces the counter and arrows. */
      const bar = document.createElement('div');
      bar.className = 'vr-scrollbar';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span></span>';
      track.after(bar);
      const thumb = bar.firstChild;
      const syncBar = () => {
        const end = track.scrollWidth - track.clientWidth;
        const share = end > 1 ? track.clientWidth / track.scrollWidth : 1;
        thumb.style.width = (share * 100) + '%';
        thumb.style.transform = 'translateX(' + (end > 1 ? (track.scrollLeft / end) * (bar.clientWidth * (1 - share)) : 0).toFixed(1) + 'px)';
      };
      track.addEventListener('scroll', syncBar, { passive: true });
      new ResizeObserver(syncBar).observe(track);
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      const observer = new ResizeObserver(sync);
      observer.observe(track);
      const unload = event => {
        if (!event.target.contains(root)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      sync();
    });
    scope.querySelectorAll('[data-vd-gallery]').forEach(gallery => {
      if (gallery.dataset.vrInit) return;
      gallery.dataset.vrInit = 'true';
      gallery.addEventListener('scroll', () => {
        if (window.matchMedia('(max-width: 749px)').matches) return;
        const selected = Math.round(gallery.scrollLeft / gallery.clientWidth);
        [...gallery.children].forEach((tile, index) => {
          if (index !== selected) tile.querySelector('video')?.pause();
        });
      }, { passive: true });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* Spec sheet: the four key figures count up the first time they come into view. */
(() => {
  const cells = document.querySelectorAll('.vs-dripl .vr-specs__key dd > span');
  if (!cells.length || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const run = el => {
    const match = el.textContent.trim().match(/^([^\d]*)(\d[\d.,]*)(.*)$/);
    if (!match) return;
    const target = parseFloat(match[2].replace(/\./g, '').replace(',', '.'));
    if (isNaN(target)) return;
    const decimals = (match[2].split(',')[1] || '').length;
    const start = performance.now();
    const duration = 1300;
    const format = n => n.toFixed(decimals).replace('.', ',');
    const step = now => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = match[1] + format(target * eased) + match[3];
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { run(entry.target); io.unobserve(entry.target); } });
  }, { threshold: 0.6 });
  cells.forEach(el => io.observe(el));
})();
